module.exports = __webpack_public_path__ + "img/cancel_status.0bcee006.svg";